<template>
  <span class="mr-2">
    <v-tooltip bottom>
      <template v-slot:activator="{ on }">
        <v-badge
          overlap
          :color="(items.length > 0 ? 'info' : '') + ' darken-1'"
          :content="items.length"
          :dot="items.length == 0"
        >
          <v-btn
            v-on="on"
            fab
            dark
            x-small
            class="ml-1"
            :color="(items.length > 0 ? 'info' : '') + ' darken-1'"
            :loading="ldg"
            @click.prevent="openDialog"
          >
            <v-icon v-text="'mdi-message-alert'" />
          </v-btn>
        </v-badge>
      </template>

      <span v-text="'Mensajes de facturación'" />
    </v-tooltip>

    <v-dialog v-model="dialog" width="95vw" max-width="1700" scrollable>
      <v-card>
        <v-toolbar dark dense elevation="1" color="info darken-1">
          <v-toolbar-title>
            <v-icon small class="mr-1" v-text="'mdi-message-alert'" />

            <span class="text-caption" v-text="'MENSAJES DE FACTURACIÓN'" />
          </v-toolbar-title>

          <v-spacer />

          <v-btn icon small dark @click.prevent="closeDialog">
            <v-icon small v-text="'mdi-close'" />
          </v-btn>
        </v-toolbar>

        <v-progress-linear v-if="ldg" indeterminate color="info" />

        <v-card-text class="pa-4">
          <v-alert v-if="!ldg && items.length == 0" dense outlined type="info">
            No hay mensajes pendientes por atender.
          </v-alert>

          <v-simple-table
            v-if="!ldg && items.length > 0"
            dense
            fixed-header
            height="70vh"
            class="notification-table"
          >
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-center column-number" v-text="'#'" />

                  <th class="column-folio" v-text="'Folio'" />

                  <th class="column-document" v-text="'Doc ID'" />

                  <th class="column-date" v-text="'Fecha'" />

                  <th class="column-type" v-text="'Tipo'" />

                  <th class="column-message" v-text="'Mensaje'" />

                  <th class="column-user" v-text="'Usuario'" />

                  <th class="text-center column-action" v-text="'Acción'" />
                </tr>
              </thead>

              <tbody>
                <tr v-for="(item, i) in items" :key="item.id">
                  <td class="text-center font-weight-bold" v-text="i + 1" />

                  <td
                    class="font-weight-bold text-no-wrap"
                    v-text="item.folio || '-'"
                  />

                  <td
                    class="text-no-wrap"
                    v-text="item.rha_bill_folio || '-'"
                  />

                  <td class="text-no-wrap" v-text="item.created_at || '-'" />

                  <td>
                    <v-chip x-small dark :color="getMessageTypeColor(item)">
                      {{ item.message_type_label || "Mensaje" }}
                    </v-chip>
                  </td>

                  <td>
                    <div class="message-preview" :title="item.message || '-'">
                      {{ item.message || "-" }}
                    </div>
                  </td>

                  <td
                    class="user-email"
                    v-text="item.created_by_email || '-'"
                  />

                  <td class="text-center">
                    <v-tooltip left>
                      <template v-slot:activator="{ on }">
                        <v-btn
                          v-on="on"
                          color="warning"
                          x-small
                          icon
                          @click.prevent="openItem(item)"
                        >
                          <v-icon small v-text="'mdi-eye'" />
                        </v-btn>
                      </template>

                      <span v-text="'Ver detalle'" />
                    </v-tooltip>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card-text>

        <v-card-actions>
          <v-spacer />

          <v-btn text small color="grey darken-1" @click.prevent="closeDialog">
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </span>
</template>

<script>
import Axios from "axios";

import { URL_API, headersToken, msgAlert } from "../control";

export default {
  data() {
    return {
      login: this.$store.getters.getLogin,

      dialog: false,
      ldg: false,

      items: [],
    };
  },

  mounted() {
    this.getItems();

    this.$root.$on("rha-bill-notifications-refresh", this.getItems);
  },

  beforeDestroy() {
    this.$root.$off("rha-bill-notifications-refresh", this.getItems);
  },

  methods: {
    openDialog() {
      this.dialog = true;
      this.getItems();
    },

    closeDialog() {
      this.dialog = false;
    },

    getMessageTypeColor(item) {
      return item.message_type_label == "Proveedor Observación"
        ? "warning"
        : "info";
    },

    getItems() {
      this.ldg = true;

      Axios.get(
        URL_API + "/notifications/rha_bill_responses",
        headersToken(this.login.token),
      )
        .then((response) => {
          if (response.data.success) {
            this.items = response.data.data || [];
          } else {
            this.$swal.fire(msgAlert("error", response.data.message));
          }
        })
        .catch((error) => {
          console.log(error);

          this.$swal.fire(
            msgAlert("error", "Error, contacte al equipo de soporte"),
          );
        })
        .finally(() => {
          this.ldg = false;
        });
    },

    openItem(item) {
      const route = this.$router.resolve({
        name: "facturacion.finder",
        params: {
          rha_bill_id: item.rha_bill_id,
        },
      });

      window.open(route.href, "_blank");
    },
  },
};
</script>

<style scoped>
.notification-table {
  width: 100%;
}

.notification-table table {
  table-layout: fixed;
  width: 100%;
}

.notification-table th,
.notification-table td {
  vertical-align: middle;
}

.column-number {
  width: 4%;
}

.column-folio {
  width: 8%;
}

.column-document {
  width: 8%;
}

.column-date {
  width: 12%;
}

.column-type {
  width: 13%;
}

.column-message {
  width: 37%;
}

.column-user {
  width: 13%;
}

.column-action {
  width: 5%;
}

.message-preview {
  display: -webkit-box;
  max-height: 84px;
  overflow: hidden;
  white-space: pre-line;
  line-height: 21px;
  word-break: break-word;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 4;
}

.user-email {
  overflow-wrap: anywhere;
}
</style>
